<template>
  <section>
    <b-table
      :loading="isLoading"
      :paginated="paginated"
      :per-page="perPage"
      :striped="isStriped"
      :hoverable="hoverable"
      default-sort="start_estimated"
      :data="executions"
    >
      <template slot-scope="props">
        <b-table-column label="Nº Salida" field="order">{{ props.row.order }}</b-table-column>
        <b-table-column label="Salida" field="start_estimated" sortable>{{ props.row.start_estimated | moment('LT')}}</b-table-column>
        <b-table-column label="Jinete" field="rider.lastname" sortable><link-to-detail type="rider" :resource-id="props.row.rider.id"> {{`${props.row.rider.lastname} ${props.row.rider.name}`}} </link-to-detail></b-table-column>
        <b-table-column label="Caballo" field="horse.name" sortable><link-to-detail type="horse" :resource-id="props.row.horse.id"> {{`${props.row.horse.name}`}} </link-to-detail></b-table-column>
        <b-table-column label="Lección" field="lesson.name" sortable>
          <lesson-pdf-button type="is-info" :lesson-id="props.row.lesson.id" :text="props.row.lesson.name"/>
        </b-table-column>
        <b-table-column label="Jueces" field="judges_executions" sortable centered>
          {{ props.row.judges_executions.length}}
        </b-table-column>
        <b-table-column label="Promedio de Nota" field="result_execution.final_score" sortable>
          <score-tag :score="props.row.result_execution != null ? props.row.result_execution.final_score : null"/>
        </b-table-column>
        <b-table-column custom-key="actions" class="is-actions-cell" field="status">
          <div class="buttons">
            <b-button
                v-if="props.row.status.code === 'finalizado' && isAdmin"
                type="is-danger"
                size="is-small"
                @click="confirmDelete(props.row)">
                Eliminar
            </b-button>
            <b-button tag="router-link"
                v-if="props.row.status.code === 'finalizado'"
                type="is-success"
                size="is-small"
                :to="{name:'detail.exercises', params: {eventId: eventId, executionId: props.row.id}}">
                Ver Detalle
            </b-button>
            <b-button tag="router-link"
                v-else-if="props.row.status.code === 'proceso'"
                type="is-dark"
                size="is-small"
                :to="{name:'evaluate.executions', params: {eventId: eventId, executionId: props.row.id}}">
                  Continuar
            </b-button>
            <b-button tag="router-link"
                v-else-if="props.row.status.code === 'pendiente'"
                type="is-primary"
                size="is-small"
                :to="{name:'evaluate.executions', params: {eventId: eventId, executionId: props.row.id}}">
                  Evaluar
            </b-button>
        </div>
        </b-table-column>
      </template>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Cargando nomina...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="horseshoe" size="is-large" />
            </p>
            <p>No hay nomina&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </section>
</template>

<script>
// import StatusTag from './StatusTag'
import ScoreTag from '@/components/ScoreTag.vue'
import LinkToDetail from '@/components/LinkToDetail'
import LessonPdfButton from '@/components/LessonPDFButton'
// import ActionButton from './ActionButton'

import ExecutionService from '@/services/ExecutionService.js'
import CredentialsService from '@/services/CredentialsService'

export default {
  components: {
    // StatusTag,
    // ActionButton,
    ScoreTag,
    LinkToDetail,
    LessonPdfButton
  },
  props: {
    eventId: {
      required: true
    }
  },
  created () {
    this.getExecutions()
  },
  data () {
    const executions = []
    return {
      executions,
      paginated: true,
      perPage: 15,
      isStriped: true,
      isNarrowed: false,
      hoverable: true,
      isFocusable: false,
      isLoading: false,
      hasMobileCards: true
    }
  },
  computed: {
    userRoles() {
      const user = CredentialsService.getUser();
      return user ? CredentialsService.getUser().roles : null
    },
    isAdmin () {
      const userRoles = this.userRoles;
      const roleFound = userRoles.find((role) => role.name === 'admin');
      return roleFound !== undefined && roleFound !== null;
    }
  },
  methods: {
    confirmDelete (execution) {
      const riderName = `${execution.rider.lastname} ${execution.rider.name}`;
      const horse = `${execution.horse.name}`;
      const lessonName = `${execution.lesson.name}`
      this.$buefy.dialog.prompt({
        title: 'Eliminar Binomio',
        type: 'is-danger',
        message: `
        Estas seguro que deseas <b>eliminar</b> el binomio?<br><br>
        <b>${riderName} / ${horse}</b><br>
        <b>${lessonName}</b><br><br>
        Esta acción no se puede deshacer.<br><small>Confirme la acción ingresando la palabra <b>ELIMINAR</b></small>.
        `,
        inputAttrs: {
            type: 'text',
            placeholder: 'Ingrese palabra de confirmación',
        },
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        trapFocus: true,
        closeOnConfirm: false,
        onConfirm: (value, {close}) => {
            
            if (value.toLowerCase() === 'eliminar') {
              close()
              this.deleteExecution(execution)
            } else {
              this.$buefy.toast.open({
                duration: 5000,
                message: `Ingrese la palabra correcta`,
                type: 'is-danger'
              })

            }

        }
    })
    },
    async deleteExecution(execution) {
      try {
        const response  = await ExecutionService.deleteExecutionData(this.eventId, execution.id);
        this.$buefy.toast.open({
            message: 'Binomio eliminado',
            type: 'is-success'
        })
      } catch (error) {
        console.log(error);
        this.$buefy.toast.open({
            message: 'Ha ocurrido un error!',
            type: 'is-danger'
        })
      }
    },
    getExecutions () {
      this.isLoading = true
      ExecutionService.getExecutions(this.eventId).then(
        response => {
          this.executions = response.data.data
          this.isLoading = false
          var index = 0
          this.executions.map((execution) => {
            execution['order'] = ++index
          })
        }
      )
    },
    calculeAge (date) {
      let years = this.moment().diff(date, 'years')
      let moths = this.moment().diff(date, 'months') / years
      return `${years} - ${moths !== 12 ? moths : 0}`
    },
    colorButton () {
      return this.status === 'Terminado' ? 'is-info' : 'is-primary'
    },
    textButton () {
      return this.status === 'Terminado' ? 'Ver Detalles' : 'Evaluar'
    }
  }
}
</script>
